import React from "react";
import { Link, useRouteMatch, useHistory } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { matchPath } from "react-router";
import HvProgress from "../../shared/HvProgress";
import { Spinner } from "react-bootstrap";
import Play from "../../../shared/Svg/Play";
import Pause from "../../../shared/Svg/Pause";
import Shuffle from "../../../shared/Svg/Shuffle";
import SkipPreviouse from "../../../shared/Svg/SkipPreviouse";
import PlayButton from "../../../shared/Svg/PlayButton";
import SkipNext from "../../../shared/Svg/SkipNext";
import Repeat from "../../../shared/Svg/Repeat";
import hv_player_api from "../../../../api/hv_player_api";
import PlayQueue from "../../../shared/Svg/PlayQueue";
import VolumeControl from "../VolumeControl";
import Menu from "../../PostsList//Post/PostHeader/Menu";
import ExternalShare from "../../../shared/Svg/ExternalShare";
import Volume from "../../../shared/Svg/Volume";
import { like, unlike } from "../../../../api/likes";
import { log_error } from "../../../../api";
import HeartOutline from "../../../shared/Svg/HeartOutline";
import HeartFilled from "../../../shared/Svg/HeartFilled";

export default ({ isActive, currently_playing, playing, progress, queue, landingPage, volume }) => {
  const history = useHistory();
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 768px)",
  });
  const flexStyle = useRouteMatch({ path: "/:slug", extact: true }) && isMobileDevice ? "flex-row" : "flex-column";
  const paddingStyle = useRouteMatch({ path: "/:slug", extact: true }) && isMobileDevice ? "pl-2 pr-2" : "";

  const heart_current_currently_playing = async () => {
    if (landingPage) return history.push("/login");
    if (currently_playing.is_liked === undefined) return;
    try {
      if (currently_playing.is_liked) {
        await unlike(currently_playing.type, currently_playing.id);
      } else {
        await like(currently_playing.type, currently_playing.id);
      }
      hv_player_api.heart();
    } catch (error) {
      console.log(log_error(error));
    }
  };
  return !isActive ? (
    <>
      {isMobileDevice && useRouteMatch({ path: "/:slug", extact: true }) && <HvProgress progress={progress} duration={currently_playing.duration} />}
      <div className={`d-flex align-items-center media-controls-wrapper ${paddingStyle}`}>
        {!isMobileDevice && <Shuffle disabled className="mr-5" />}
        {isMobileDevice && useRouteMatch({ path: "/:slug", extact: true }) && (
          <div className="track-details">
            <Link className="user-link track-title" to={`/${currently_playing.user && currently_playing.user.slug}`}>
              {currently_playing.user && currently_playing.user.username}
            </Link>
            <Link className="user-link user-slug" to={`/${currently_playing.user && currently_playing.user.slug}`}>
              {currently_playing.user && currently_playing.user.username}
            </Link>
          </div>
        )}
        <div className={`d-flex ${flexStyle} w-100`}>
          <div className="d-flex justify-content-around align-items-center mb-2 prev-next-wrapper">
            {isMobileDevice ? !useRouteMatch({ path: "/:slug", extact: true }) && <SkipPreviouse disabled /> : <SkipNext disabled />}
            <Play disabled />
            {isMobileDevice ? !useRouteMatch({ path: "/:slug", extact: true }) && <SkipNext disabled /> : <SkipNext disabled />}
          </div>
          {!isMobileDevice && <HvProgress disabled />}
        </div>
        {isMobileDevice && !useRouteMatch({ path: "/:slug", extact: true }) && (
          <div className="d-flex align-items-center">
            {!isMobileDevice && <ExternalShare disabled className="mr-2" />}
            <HeartOutline disabled className="mr-2" />
            <Shuffle disabled className="mr-2" />
            <Repeat disabled className="mr-2" />
            <Volume disabled className="mr-2" />
          </div>
        )}
        {!isMobileDevice && <Repeat disabled className="ml-5" />}
      </div>
    </>
  ) : (
    <>
      {isMobileDevice && useRouteMatch({ path: "/:slug", extact: true }) && <HvProgress progress={progress} duration={currently_playing.duration} />}
      <div className={`d-flex align-items-center media-controls-wrapper ${paddingStyle}`}>
        {!isMobileDevice && (
          <>
            {!isMobileDevice && (
              <Menu object={currently_playing} type={currently_playing.type} socialMediaOnly>
                <ExternalShare className="mr-2" />
              </Menu>
            )}
            {currently_playing.is_liked ? (
              <HeartFilled className="mr-2" color="#f0047f" onClick={heart_current_currently_playing} />
            ) : (
              <HeartOutline className="mr-2" onClick={heart_current_currently_playing} />
            )}
            <Shuffle className="mr-5" />
          </>
        )}
        <div className={`d-flex ${flexStyle} w-100`}>
          <div className="d-flex justify-content-around align-items-center mb-2 prev-next-wrapper">
            {isMobileDevice ? (
              !useRouteMatch({ path: "/:slug", extact: true }) && (
                <SkipPreviouse disabled={!queue || !queue.current_track_index} onClick={hv_player_api.prev} />
              )
            ) : (
              <SkipPreviouse disabled={!queue || !queue.current_track_index} onClick={hv_player_api.prev} />
            )}
            {currently_playing.status === "ready" ? (
              playing ? (
                <Pause className="pause-button" onClick={hv_player_api.pause} />
              ) : (
                <PlayButton onClick={hv_player_api.play} className="play-button" />
              )
            ) : (
              <Spinner animation="border" variant="white" size="lg" role="status" style={{ width: "1.5rem", height: "1.5rem" }} />
            )}
            {isMobileDevice ? (
              !useRouteMatch({ path: "/:slug", extact: true }) && (
                <SkipNext disabled={!queue || queue.queue.length - 1 <= queue.current_track_index} onClick={hv_player_api.next} />
              )
            ) : (
              <SkipNext disabled={!queue || queue.queue.length - 1 <= queue.current_track_index} onClick={hv_player_api.next} />
            )}
          </div>
          {!isMobileDevice && <HvProgress progress={progress} duration={currently_playing.duration} />}
          {isMobileDevice && useRouteMatch({ path: "/:slug", extact: true }) && (
            <div className="track-details" style={{ paddingLeft: 20 }}>
              <Link
                style={{
                  width: "107px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                className="user-link track-title"
                to={`/${currently_playing.user && currently_playing.user.slug}`}
              >
                {currently_playing.title}
              </Link>
              <Link
                style={{
                  width: "107px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                className="user-link user-slug"
                to={`/${currently_playing.user && currently_playing.user.slug}`}
              >
                {currently_playing.user && currently_playing.user.username}
              </Link>
            </div>
          )}
        </div>
        {isMobileDevice && !useRouteMatch({ path: "/:slug", extact: true }) && (
          <div className="d-flex align-items-center">
            <Menu object={currently_playing} type={currently_playing.type} socialMediaOnly>
              <ExternalShare />
            </Menu>
            <Shuffle className="mr-2" />
            <Repeat className="mr-2" />
            <VolumeControl volume={volume} />
          </div>
        )}
        {!isMobileDevice && (
          <div className="pl-5 d-flex">
            <Repeat />
            {!landingPage && (
              <Link to="/now-playing" className="ml-2">
                <PlayQueue />
              </Link>
            )}
          </div>
        )}
      </div>
    </>
  );
};
